import { isRouteErrorResponse, useRouteError } from "react-router";

import * as Sentry from "@sentry/react";

import ErrorFallback from "~/components/ErrorBoundary/ErrorFallback";
import NotFoundPage from "~/pages/NotFoundPage";

const RouteErrorBoundary = () => {
  const error = useRouteError();

  if (isRouteErrorResponse(error) && error.status === 404) {
    return <NotFoundPage />;
  }

  Sentry.captureException(error);

  return (
    <ErrorFallback
      error={error instanceof Error ? error : new Error(String(error))}
      errorInfo={null}
      mode="fullpage"
    />
  );
};

export default RouteErrorBoundary;
